import { isFunction } from '@r-and-a-shared-ui/utils';
import { Fragment } from 'react';
import {
  FormFieldPreviewTypes,
  formFieldsPreviewConfig,
} from '../../config/form-field-preview-config';
import { BaseFormFieldProps, OptionProps } from '../../FormField/FormField';

export type FormFieldPreviewProps = {
  name: string;
  label?: string;
  fieldType: FormFieldPreviewTypes;
  hideLabel?: boolean;
  options?: OptionProps[];
  subfields?: BaseFormFieldProps[];
};
export const FormFieldPreview = (props: FormFieldPreviewProps) => {
  const { fieldType } = props as FormFieldPreviewProps;

  if (!isFunction(formFieldsPreviewConfig[fieldType])) {
    return undefined;
  }

  return <Fragment>{formFieldsPreviewConfig[fieldType](props)}</Fragment>;
};

export default FormFieldPreview;
